<dialog
  #dialog
  qai-dialog
  [heading]="'Edit scoring weighting'"
  [description]="description"
  (afterClose)="handleClose()"
>
  <qai-item-grid
    [repeatCount]="'auto-fill'"
    [gap]="'40px'"
    [minItemWidth]="'140px'"
  >
    <qai-score-weightage
      *ngFor="let weight of localWeights; let i = index"
      [title]="weight.section"
      [enabled]="weight.value !== 0"
      [weight]="weight.value"
      [border]="false"
      [hasError]="fieldErrors['weight-' + i]"
      [enabledLabel]="'Enabled'"
      [disabledLabel]="'Disabled'"
      (checkboxEvent)="onDisableChange($event, i)"
      (inputFieldEvent)="onWeightInputChange($event, i)"
    ></qai-score-weightage>
  </qai-item-grid>
  <div class="error-message" *ngIf="errorMessage">
    {{ errorMessage }}
  </div>
  <div class="modal-actions">
    <button
      qai-button
      kind="secondary"
      [size]="'medium'"
      style="width: 100%"
      (click)="hideModal()"
    >
      Cancel
    </button>
    <button
      qai-button
      kind="primary"
      [size]="'medium'"
      style="width: 100%"
      (click)="handleConfirm()"
      [disabled]="hasErrors()"
    >
      Confirm
    </button>
  </div>
</dialog>
